'use es6';

import { Record } from 'immutable';
import { RequestStatus } from '../constants/base';
const defaults = {
  emailsNotSent: 0,
  emailsSent: 0,
  registered: 0,
  status: RequestStatus.UNINITIALIZED,
  unregistered: 0
};
export default class ListRegistrations extends Record(defaults) {}